export class ConstantsTableColsErgSocSo {
  static readonly SOC_CODE: string = 'SOC_CODE';
  static readonly SOC_MERKMAL: string = 'SOC_MERKMAL';
  static readonly MENGEEINHEIT: string = 'MENGEEINHEIT';

  static readonly MENGE: string = 'MENGE';
  static readonly BEZUGSEINHEIT: string = 'BEZUGSEINHEIT';
  static readonly SO_KOEFFIZIENT: string = 'SO_KOEFFIZIENT';
  static readonly SO_BETRAG: string = 'SO_BETRAG';
  static readonly SALDO: string = 'SALDO';
  static readonly SO_BETRAG_BEREINIGT: string = 'SO_BETRAG_BEREINIGT';
  static readonly BEMERKUNG: string = 'BEMERKUNG';

  public static getColumns(): string[] {
    return [
      this.SOC_CODE,
      this.SOC_MERKMAL,
      this.MENGE,
      this.MENGEEINHEIT,
      this.SO_KOEFFIZIENT,
      this.BEZUGSEINHEIT,
      this.SO_BETRAG,
      this.SALDO,
      this.SO_BETRAG_BEREINIGT,
      this.BEMERKUNG,
    ];
  }
}
